<template>
  <div class="hs-tab" :style="{ height: height }" :type="type">
    <!--特别的左右宽度不一致 单独特别处理-->
    <template v-if="type === 'homePlaneAndHotel'">
      <div
          class="item item-home"
          :type="language"
          :class="{ 'item-active': currentIndex === index }"
          :style="{ width: `${100 / options.length}%` }"
          v-for="(item, index) in options"
          :key="index"
          :ref="`HsTab${index}`"
          @click="_select(index)"
      >
        <span v-html="item"></span>
      </div>
      <div class="slider-bar slider-bar-home"
          :class="{'slider-bar-right': options.length > 1 &&currentIndex === 0, 'slider-bar-left': options.length > 1 && currentIndex === options.length - 1}"
          :style="{ width: sliderBarWidth, transform: left, height: options.length > 1 ? '46px' : '42px' }"
      ><span></span></div>
    </template>
    <!--特别的左右宽度不一致 单独特别处理-->
    <template v-else-if="type === 'hotelQueryTab'">
      <div
        class="item"
        :type="language"
        :class="{ 'item-active': currentIndex === index }"
        :style="{ width: `${100 / options.length}%` }"
        v-for="(item, index) in options"
        :key="index"
        :ref="`HsTab${index}`"
        @click="_select(index)"
      >
        <span v-html="item"></span>
      </div>
      <div
        class="slider-bar"
        :style="{ width: sliderBarWidth, transform: left }"
      ></div>
    </template>
    <template v-else>
      <div
        class="item"
        :type="language"
        :class="{ 'item-active': currentIndex === index }"
        :style="{ width: `${100 / options.length}%` }"
        v-for="(item, index) in options"
        :key="index"
        @click="_select(index)"
      >
        <span :ref="`HsTab${index}`" v-html="item"></span>
      </div>
      <div
        class="slider-bar"
        :style="{ width: sliderBarWidth, transform: left }"
      ></div>
    </template>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  name: 'hs-tab-2',
  props: {
    options: {
      type: Array,
      default: function() {
        return []
      },
      required: true
    },
    selectedIndex: {
      type: Number,
      default: 0
    },
    height: {
      type: String,
      default: '40px'
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentIndex: this.selectedIndex,
      sliderBarWidth: `${100 / this.options.length}%`,
      left: `translateX(${100 * this.currentIndex}%)`
    }
  },
  watch: {
    selectedIndex(val) {
      // this.currentIndex = val
      this._select(val)
    },
    options() {
      this.sliderBarWidth = `${100 / this.options.length}%`
    }
  },
  methods: {
    _select(index) {
      if (this.type === 'homePlaneAndHotel' && !this.options[index]) {
        return
      }
      this.currentIndex = index
      if (this.$refs[`HsTab${index}`] && this.$refs[`HsTab${index}`][0]) {
        // this.sliderBarWidth = this.$refs[`HsTab${index}`][0].clientWidth + 'px'
        // this.left = this.$refs[`HsTab${index}`][0].offsetLeft + 'px'
        if (this.type === 'hotelQueryTab') {
          this.sliderBarWidth = this.$refs[`HsTab${index}`][0].clientWidth + 'px'
          this.left = `translateX(${this.$refs[`HsTab${index}`][0].offsetLeft}px)`
        } else {
          this.sliderBarWidth = `${100 / this.options.length}%`
          this.left = `translateX(${100 * this.currentIndex}%)`
        }
      }
      this.$emit('select', index)
    }
  },
  mounted() {
    this._select(this.selectedIndex)
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-tab
  @extend .flex-row
  @extend .flex-between
  width 100%
  position relative
  background-color $color_background_gray_3
  // overflow auto
  border-radius 18px 18px 0 0
  &[type="homePlaneAndHotel"]
    border-radius 12px 12px 0 0
    background-color $color_black_30
    >.item
      @extend .hs-font-subtitle-big
      color $color_black_900
    >.item-active
      color $color_theme_300
      >span
        font-weight 500
    >.slider-bar-home
      display flex
      align-items flex-end
      justify-content center
      >span
        width 16px
        height 4px
        background-color $color_theme_300
        border-radius 4px 4px 0 0
  >.item
    @extend .flex-center
    @extend .no-wrap
    height 100%
    font-size 1rem
    color $color_font_gray_1
    padding 0 5px
    text-align center
  >.item[type="EN"],>.item[type="JAP"]
    font-size 0.8rem
  >.item-active
    color $color_font_black
    span
      font-weight bold
      position relative
      z-index 1
  >.slider-bar
    position absolute
    left 0
    bottom 0
    height 55px
    border-radius 18px 18px 0 0
    background-color $color_white
    transition all 300ms
    &::before
      content ' '
      position absolute
      bottom 0
      left -33px
      width 38px
      height 46px
      background url(@/assets/image/base/hs-tab/radius-left.png)
      background-size 100% 100%
    &::after
      content ' '
      position absolute
      bottom 0
      right -33px
      width 38px
      height 46px
      background url(@/assets/image/base/hs-tab/radius-right.png)
      background-size 100% 100%
    &.slider-bar-home
      &.slider-bar-right
        &::before
          display none
        &::after
          right -16px
          width 32px
          height 46px
          background url(@/assets/image/base/hs-tab/rectangle_right.svg)
          background-size 100% 100%
      &.slider-bar-left
        &::before
          left -16px
          width 32px
          height 46px
          background url(@/assets/image/base/hs-tab/rectangle_left.svg)
          background-size 100% 100%
        &::after
          display none
</style>
